module.exports = __webpack_public_path__ + "assets/lessons/en/lesson4/pages/lesson_4_3.pdf";